import React from 'react';
import {Outlet} from 'react-router-dom'

const RootPage = () => {
    return (
        <Outlet/>
    );
};

export default RootPage;